import { SignalsHistoryAll } from 'libs/ui';

export const SignalsHistory = () => {
  return <SignalsHistoryAll apiMethod="get_all_events_history" />;
};
